import _styled from '@emotion/styled/base';
import { spacing } from '@hubble/tokens/web';
import { Flex } from '../../Flex/index.js';

const ComposableEmptyStateWrapper = _styled(Flex, {
  target: "ehvjzi02"
})("min-height:256px;min-width:256px;width:100%;gap:", spacing[16], ";flex-direction:column;align-items:center;justify-content:center;padding:", spacing[32], " ", spacing[48], ";box-sizing:border-box;text-align:center;");
const ComposableEmptyStateTextWrapper = _styled(Flex, {
  target: "ehvjzi01"
})("flex-direction:column;align-items:center;text-align:center;gap:", spacing[8], ";");
const ComposableEmptyStateActionsWrapper = _styled(Flex, {
  target: "ehvjzi00"
})("flex-direction:column;align-items:center;gap:", spacing[12], ";");

export { ComposableEmptyStateActionsWrapper, ComposableEmptyStateTextWrapper, ComposableEmptyStateWrapper };
